import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import './PageHeader.css';

const PageHeader = ({
  title,
  backTo = -1,
  rightButton = null,
  showBackButton = true
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof backTo === 'string') {
      navigate(backTo);
    } else {
      navigate(backTo);
    }
  };

  return (
    <div className="page-header-component">
      {showBackButton && (
        <button className="btn-back-header" onClick={handleBack}>
          <ArrowLeft size={20} />
        </button>
      )}
      <h1 className="page-title-header">{title}</h1>
      {rightButton && <div className="header-right">{rightButton}</div>}
    </div>
  );
};

export default PageHeader;
